import { productCardAnimations } from "../../animations/productCardAnimations.js";
import { createCard } from "../../createCard.js";

export async function addCardsCatalog(data, section) {
  const fragment = document.createDocumentFragment();

  const promises = data.map(async (info) => {
    const card = await createCard(info);
    fragment.appendChild(card);
  });

  Promise.all(promises).then(() => {
    section.appendChild(fragment);
    productCardAnimations(section);
  });
}

export function addProductCountValue(count = 0) {
  const items = document.querySelectorAll(".filters-block__total-quantity");
  Array.from(items).forEach((el) => {
    const words = ["товар", "товара", "товаров"];
    let variant = 0;

    if (count % 10 == 1 && count % 100 != 11) {
      variant = 0;
    } else if (
      2 <= count % 10 <= 4 &&
      (count % 100 < 10 || count % 100 >= 20)
    ) {
      variant = 1;
    } else {
      variant = 2;
    }
    el.innerText = `${count} ${words[variant]}`;
  });
}
